module.exports = __webpack_public_path__ + "static/img/3.8f9020b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/3.png
// module id = PLqO
// module chunks = 0